import React, { Component } from 'react';
import FuelerIcon from './components/FuelerIcon';
import Drawer from './components/Drawer';
import AppHeaderInfo from './AppHeaderInfo';
import AppNavigation from './AppNavigation';
import styled from 'styled-components';

const RelativeContainer = styled.div`
    position: relative;
`;

const AppHeaderContainer = styled.div`
    background-color: ${props => props.theme.primaryBackgroundColor};
    height: 50px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawerOpen: false
        };

        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    toggleDrawer() {
        this.setState({
            drawerOpen: !this.state.drawerOpen
        });
    }

    closeDrawer() {
        this.setState({
            drawerOpen: false
        });
    }

    render() {
        return (
            <RelativeContainer>
                <AppHeaderContainer style={{ justifyContent: this.props.loggedIn ? 'space-between' : 'center' }}>
                    <FuelerIcon icon="fueler" size="70px" />
                    {this.props.loggedIn && (
                        <AppHeaderInfo
                            online={this.props.online}
                            user={this.props.user}
                            syncNumber={this.props.syncNumber}
                        />
                    )}
                    {this.props.loggedIn && (
                        <FuelerIcon
                            onClick={this.toggleDrawer}
                            icon="settings"
                            size="34px"
                            fill="#CC3E2B"
                            stroke="#FFFFFF"
                        />
                    )}
                </AppHeaderContainer>
                {this.props.children}
                <Drawer open={this.state.drawerOpen} onClick={this.closeDrawer}>
                    <AppNavigation online={this.props.online} />
                </Drawer>
            </RelativeContainer>
        );
    }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/AppHeader.js